module.exports = __webpack_public_path__ + "img/吉禾.43e855be.png";